<template>
  <div class="home-content" @click="handleClick">
    <Head ref="head" :backFn="back"></Head>
    <div :class="[isMaxScreen ? 'pc_FAQs-container' : 'FAQs-container']">
      <div class="page-text-container" v-html="workData"></div>
    </div>
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { isES,lang } from '@/locales';
import { getChannelId } from '@/utils/channel';

import Bottom from '../../components/bottom';
import Head from '../../components/head';
import { atofflineDeData } from './atofflineDeData.js'
import { atonlineDeData } from './atonlineDeData.js'
import { atonlineEnData } from './atonlineEnData.js'
import { enData } from './enData.js';
import { esData } from './esData.js';
export default {
  name: 'Home',
  components: {
    Head,
    Bottom
  },
  data() {
    return {
      isES
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => state.isMaxScreen,
      channel() {
        // 使用封装的方法获取渠道 ID
        return getChannelId();
      },
      workData() {
        // 根据渠道和语言返回对应的数据
        if (!this.channel || this.channel === '' || this.channel === '100000') {
          // 普通渠道：支持英语和西班牙语
          return lang === 'es' ? esData : enData
        } else if (this.channel === '100070') {
          // 线上渠道：支持英语和德语
          return lang === 'de' ? atonlineDeData : atonlineEnData
        } else if (this.channel === '100080') {
          // 线下渠道：只支持德语
          return atofflineDeData
        }
        // 默认返回英语
        return enData

      }
    })
  },
  created() {
    // 不再从 route 获取，统一使用getChannelId() 方法
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    handleClick() {
      this.$refs.head.hidLangeList();
    },
    back() {
      this.$router.push({ name: 'Home' });
    },
    // 跳转页面
    toPage(name) {
      if (!this.checked && name === 'Product') {
        return;
      }
      this.$router.push({ name });
    }
  }
};
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  .home-content {
    width: 100%;
    min-height: 100%;
    background: #fff;
    font-family: 'PingFang SC';
    .pc_FAQs-container {
      padding: 160px 0 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      /deep/.page-title {
        color: #252629;
        text-align: center;
        font-family: 'PingFang SC';
        font-size: 40px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        margin-bottom: 20px;
      }
      /deep/.page-text-container {
        max-width: 1400px;
        margin: auto;
        .paragraph {
          margin-bottom: 32px;

          .title {
            color: #252629;
            font-family: 'PingFang SC';
            font-size: 24px;
            font-style: normal;
            font-weight: 500;
            line-height: 150%;
            margin-bottom: 12px;
          }
          .text-box {
            .text {
              color: #333;
              font-family: 'PingFang SC';
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
              .email {
                color: #165dff;
                font-family: 'PingFang SC';
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
@media (max-width: 980px) {
  .home-content {
    width: 100%;
    min-height: 100%;
    background: #fff;
    font-family: 'PingFang SC';
    .FAQs-container {
      padding: 148px 30px 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      /deep/.page-title {
        color: #252629;
        text-align: center;
        font-family: 'PingFang SC';
        font-size: 48px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%;
        margin-bottom: 48px;
      }
      /deep/.page-text-container {
        width: 100%;
        .paragraph {
          margin-bottom: 32px;

          .title {
            color: #252629;
            font-family: 'PingFang SC';
            font-size: 32px;
            font-style: normal;
            font-weight: 500;
            line-height: 150%;
            margin-bottom: 24px;
          }
          .text-box {
            .text {
              color: #333;
              font-family: 'PingFang SC';
              font-size: 28px;
              font-style: normal;
              font-weight: 400;
              line-height: 150%;
              .email {
                color: #165dff;
                font-family: 'PingFang SC';
                font-size: 28px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%;
                cursor: pointer;
              }
            }
          }
        }
      }
    }
  }
}
</style>
